interface IConfig {
	spinner?: boolean;
	showError?: boolean;

	params?: any;
	method?: any;
	cache?: any;
	headers?: any;
	user?: ILocalUser;
}

import { firebaseAuth, authReady } from './firebase';

async function authHeader(): Promise<Record<string, string>> {
	let u = firebaseAuth.currentUser;
	if (!u) {
		try { u = await authReady; } catch { return {}; }
	}
	try {
		const idToken = await u.getIdToken();
		return { Authorization: `Bearer ${idToken}` };
	} catch {
		return {};
	}
}

class HTTP {
	async get(url: string, config?: IConfig) {
		let _config: RequestInit = {
			method: 'GET',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json',
				...(await authHeader())
			}
		};

		if (config) Object.assign(_config, config);
		return this._fetch(url, _config);
	}

	async post(url: string, data: any, config?: IConfig) {
		let _config: RequestInit = {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json',
				...(await authHeader())
			},
			body: JSON.stringify(data)
		};
		if (config) Object.assign(_config, config);
		return this._fetch(url, _config);
	}

	async put(url: string, data: any) {
		let config: RequestInit = {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json',
				...(await authHeader())
			},
			body: JSON.stringify(data)
		};
		return this._fetch(url, config);
	}

	async del(url: string, config?: IConfig) {
		let _config: RequestInit = {
			method: 'DELETE',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json',
				...(await authHeader())
			}
		};

		if (config) Object.assign(_config, config);
		return this._fetch(url, _config);
	}

	_fetch(url: string, config: RequestInit) {
		return fetch(url, config).then(r => {
			const contentType = r.headers.get('content-type');
			let isjson = contentType && contentType.indexOf('application/json') !== -1;

			if (!r.ok) {
				if (r.status === 401) {
					return;
				}
				if (isjson) {
					r.json().then(msg => {
						console.error(msg.message || msg);
					});
				}
				throw new Error(r.statusText);
			} else if (isjson) {
				return r.json();
			} else {
				return r.text();
			}
		});
	}
}

export const http = new HTTP();
